<style lang="scss">
@import '~scss/_variables';

.units-switch {
	font-size: 14px;

	button {
		padding: 5px 8px 4px 8px;
		border-radius: 5px;

		font-family: $font-family-1;
		text-transform: uppercase;
		color: $color-black;

		transition:
			opacity $transition-hover,
			background $transition-1,
			color $transition-1;

		&:not(.is-active):hover {
			opacity: 0.7;
		}

		&.is-active {
			background: $color-text-2;
			color: $color-accent-1;
		}

		& + button {
			margin-left: 4px;
		}
	}
}
</style>

<template>
	<div class="units-switch">
		<button
			v-for="unit in options"
			:key="unit.id"
			:class="{
				'is-active': active === unit.id
			}"
			@click="$emit('change', unit.id)"
		>
			{{ unit.text }}
		</button>
	</div>
</template>

<script>
export default {
	props: {
		active: {
			type: String,
			default: 'metric'
		}
	},
	data () {
		return {
			options: [
				{
					id: 'metric',
					text: 'Metric'
				},
				{
					id: 'imperial',
					text: 'Imperial'
				}
			]
		};
	}
}
</script>